/* eslint-disable no-undef */
// @ts-nocheck
//928288071099925 sandbox
// 1272085639484790 huft
let pixelId;
let pixelList;
export const callSnapchat = (data) => {
  if (data.stepName == 'START_CHECKOUT') {
    pixelList = data.pixelData.pixelId?.split(',');
    pixelList?.forEach((el) => {
      pixelId = el;
      if (el) initPageViewEvt(data);
    });
  }
  snapchatAnalyticsEvent(data);
};

function initPageViewEvt(data) {
  let eventData = { user_phone_number: data.pixelData?.phone };
  data.pixelData?.email && (eventData.user_email = data.pixelData?.email);
  snaptr('init', pixelId, eventData);
}

const snapchatAnalyticsEvent = (data) => {
  snaptr('track', data.stepName, {
    currency: data.currency,
    price: data.totalValue,
    client_dedup_id: data.client_dedup_id,
    description: data.description,
    item_ids: data.commonAnalyticsData.pidArr,
    item_category: data.commonAnalyticsData.productType,
    geo_country: 'India',
    number_items: data.commonAnalyticsData.total_quantity,
    transaction_id: data.moid,
    event_tag: 'gokwik',
    firstname: data.userAddress?.firstname,
    lastname: data.userAddress?.lastname,
    geo_region: data.userAddress?.state,
    geo_postal_code: data.userAddress?.pincode,
  });
};
